<div class="erg-fb-triggers">
  <button id="ergFbTrigger" type="button" class="erg-fb-trigger" (click)="open()"
    aria-haspopup="dialog" aria-controls="ergFbDialog">
    <i class="fa fa-comment-o" aria-hidden="true"></i>
    <span>Share Feedback</span>
  </button>
  <!-- <button id="ergFbResponsesTrigger" type="button" *ngIf="isAdmin"
    class="erg-fb-trigger erg-fb-trigger-admin" (click)="openResponses()"
    aria-haspopup="dialog" aria-controls="ergFbDialog">
    <i class="fa fa-list-ul" aria-hidden="true"></i>
    <span>View responses</span>
  </button> -->
</div>

<div class="erg-fb-overlay" *ngIf="isOpen" (click)="onOverlayClick($event)">
  <div id="ergFbDialog" class="erg-fb-dialog" [class.erg-fb-dialog-responses]="view === 'responses'"
    role="dialog" aria-modal="true" aria-labelledby="ergFbTitle"
    [attr.aria-describedby]="view === 'form' ? 'ergFbDescription' : view === 'responses' ? 'ergFbResponsesDescription' : view === 'success' ? 'ergFbSuccessDescription' : 'ergFbDiscardDescription'"
    cdkTrapFocus [cdkTrapFocusAutoCapture]="true">
    <button id="ergFbClose" type="button" class="erg-fb-close" (click)="requestClose()"
      [disabled]="isSubmitting"
      [attr.aria-label]="view === 'responses' ? 'Close feedback responses' : view === 'discard' ? 'Keep editing feedback' : 'Close feedback'"
      [attr.title]="view === 'discard' ? 'Keep editing' : 'Close'">
      <i class="fa fa-times" aria-hidden="true"></i>
    </button>

    <form *ngIf="view === 'form'" (ngSubmit)="submit()" novalidate>
      <header class="erg-fb-header">
        <span class="erg-fb-kicker">ERG Connect</span>
        <h4 class="erg-fb-title" id="ergFbTitle">Share your feedback</h4>
        <p class="erg-fb-subtitle" id="ergFbDescription">
          Tell us how the app worked for you. Your feedback goes directly to the product team.
        </p>
      </header>

      <div id="ergFbFormError" class="erg-fb-error" *ngIf="errorMessage" role="alert" tabindex="-1">
        <i class="fa fa-exclamation-circle" aria-hidden="true"></i>
        <span>{{ errorMessage }}</span>
      </div>

      <div class="erg-fb-validation-summary" *ngIf="submitAttempted && !formIsValid" role="alert">
        Please complete the highlighted fields before sending your feedback.
      </div>

      <fieldset class="erg-fb-question" [class.erg-fb-question-invalid]="submitAttempted && !ratingIsValid">
        <legend class="erg-fb-label">
          How was your experience? <span class="erg-fb-req" aria-hidden="true">*</span>
        </legend>
        <div class="erg-fb-rating-options">
          <label *ngFor="let option of ratingOptions" class="erg-fb-rating-option"
            [class.erg-fb-option-selected]="experienceRating === option.value">
            <input class="erg-fb-native-radio" type="radio" name="experienceRating"
              [id]="'ergFbRating' + option.value" [value]="option.value"
              [(ngModel)]="experienceRating" required
              [attr.aria-invalid]="submitAttempted && !ratingIsValid"
              [attr.aria-describedby]="submitAttempted && !ratingIsValid ? 'ergFbRatingError' : null">
            <span class="erg-fb-option-content erg-fb-rating-content">
              <span class="erg-fb-rating-number">{{ option.value }}</span>
              <span class="erg-fb-option-label">{{ option.label }}</span>
            </span>
          </label>
        </div>
        <p id="ergFbRatingError" class="erg-fb-field-error" *ngIf="submitAttempted && !ratingIsValid">
          Choose an experience rating.
        </p>
      </fieldset>

      <fieldset class="erg-fb-question" [class.erg-fb-question-invalid]="submitAttempted && !feedbackTypeIsValid">
        <legend class="erg-fb-label">
          What kind of feedback is this? <span class="erg-fb-req" aria-hidden="true">*</span>
        </legend>
        <div class="erg-fb-type-options">
          <label *ngFor="let option of feedbackTypeOptions" class="erg-fb-type-option"
            [class.erg-fb-option-selected]="feedbackType === option.value">
            <input class="erg-fb-native-radio" type="radio" name="feedbackType"
              [id]="'ergFbType' + option.value" [value]="option.value"
              [(ngModel)]="feedbackType" required
              [attr.aria-invalid]="submitAttempted && !feedbackTypeIsValid"
              [attr.aria-describedby]="submitAttempted && !feedbackTypeIsValid ? 'ergFbTypeError' : null">
            <span class="erg-fb-option-content erg-fb-type-content">
              <i class="fa" [ngClass]="option.icon" aria-hidden="true"></i>
              <span>{{ option.label }}</span>
            </span>
          </label>
        </div>
        <p id="ergFbTypeError" class="erg-fb-field-error" *ngIf="submitAttempted && !feedbackTypeIsValid">
          Choose a feedback type.
        </p>
      </fieldset>

      <div class="erg-fb-question" [class.erg-fb-question-invalid]="submitAttempted && !detailsAreValid">
        <label class="erg-fb-label" for="ergFbDetails">
          Tell us more <span class="erg-fb-req" aria-hidden="true">*</span>
        </label>
        <p class="erg-fb-field-help" id="ergFbDetailsHelp">Specific details help us understand what to improve.</p>
        <textarea id="ergFbDetails" name="feedbackDetails" class="erg-fb-textarea" rows="5"
          maxlength="500" required [placeholder]="detailsPlaceholder" [(ngModel)]="feedbackDetails"
          [attr.aria-invalid]="submitAttempted && !detailsAreValid"
          [attr.aria-describedby]="submitAttempted && !detailsAreValid ? 'ergFbDetailsHelp ergFbDetailsCount ergFbDetailsError' : 'ergFbDetailsHelp ergFbDetailsCount'"></textarea>
        <div class="erg-fb-field-foot">
          <p id="ergFbDetailsError" class="erg-fb-field-error" *ngIf="submitAttempted && !detailsAreValid">
            Enter feedback details.
          </p>
          <span id="ergFbDetailsCount" class="erg-fb-counter">{{ feedbackDetails.length }}/500</span>
        </div>
      </div>

      <div class="erg-fb-actions">
        <button id="ergFbCancel" type="button" class="erg-fb-btn-outline" (click)="requestClose()">Cancel</button>
        <button id="ergFbSubmit" type="submit" class="erg-fb-btn-primary" [disabled]="isSubmitting">
          <ng-container *ngIf="!isSubmitting">
            <i class="fa fa-paper-plane" aria-hidden="true"></i>
            Send feedback
          </ng-container>
          <ng-container *ngIf="isSubmitting">
            <i class="fa fa-spinner fa-spin" aria-hidden="true"></i>
            Sending...
          </ng-container>
        </button>
      </div>
    </form>

    <section *ngIf="view === 'success'" class="erg-fb-state erg-fb-success" aria-live="polite">
      <span class="erg-fb-state-icon erg-fb-success-icon">
        <i class="fa fa-check" aria-hidden="true"></i>
      </span>
      <h4 class="erg-fb-title" id="ergFbTitle">Feedback sent</h4>
      <p class="erg-fb-subtitle" id="ergFbSuccessDescription">
        Thank you for helping us make ERG Connect better.
      </p>
      <div class="erg-fb-actions erg-fb-actions-center">
        <button type="button" class="erg-fb-btn-outline" (click)="startNewFeedback()">Share more feedback</button>
        <button id="ergFbSuccessClose" type="button" class="erg-fb-btn-primary" (click)="requestClose()">Close</button>
      </div>
    </section>

    <section *ngIf="view === 'discard'" class="erg-fb-state erg-fb-discard">
      <span class="erg-fb-state-icon erg-fb-discard-icon">
        <i class="fa fa-exclamation-triangle" aria-hidden="true"></i>
      </span>
      <h4 class="erg-fb-title" id="ergFbTitle">Discard your feedback?</h4>
      <p class="erg-fb-subtitle" id="ergFbDiscardDescription">
        Your answers have not been sent. You can keep editing or discard them and close.
      </p>
      <div class="erg-fb-actions erg-fb-actions-center">
        <button type="button" class="erg-fb-btn-outline erg-fb-discard-keep" (click)="keepEditing()">
          Keep editing
        </button>
        <button type="button" class="erg-fb-btn-primary" (click)="discardFeedback()">Discard</button>
      </div>
    </section>

    <section *ngIf="view === 'responses'" class="erg-fb-viewer">
      <header class="erg-fb-header erg-fb-viewer-header">
        <span class="erg-fb-kicker">Super admin</span>
        <h4 class="erg-fb-title" id="ergFbTitle">Feedback responses</h4>
        <p class="erg-fb-subtitle" id="ergFbResponsesDescription">
          Review product feedback submitted by ERG Connect users<span *ngIf="!isLoadingResponses && !responsesError"> ({{ responses.length }} total)</span>.
        </p>
      </header>

      <div class="erg-fb-empty" *ngIf="isLoadingResponses" role="status" aria-live="polite">
        <i class="fa fa-spinner fa-spin" aria-hidden="true"></i>
        Loading responses...
      </div>

      <div class="erg-fb-response-error" *ngIf="responsesError" role="alert">
        <div class="erg-fb-error">
          <i class="fa fa-exclamation-circle" aria-hidden="true"></i>
          <span>{{ responsesError }}</span>
        </div>
        <button type="button" class="erg-fb-btn-outline" (click)="loadResponses()">
          <i class="fa fa-refresh" aria-hidden="true"></i>
          Retry
        </button>
      </div>

      <div *ngIf="!isLoadingResponses && !responsesError && responses.length === 0" class="erg-fb-empty">
        <i class="fa fa-inbox" aria-hidden="true"></i>
        <strong>No feedback yet</strong>
        <span>New responses will appear here.</span>
      </div>

      <div *ngIf="!isLoadingResponses && !responsesError && responses.length > 0" class="erg-fb-responses">
        <article class="erg-fb-response-card" *ngFor="let response of responses; trackBy: trackResponse">
          <header class="erg-fb-response-head">
            <div>
              <span class="erg-fb-response-idx">Response #{{ response.feedbackId }}</span>
              <span class="erg-fb-response-date">{{ response.submittedDate | date:'medium' }}</span>
            </div>
            <span class="erg-fb-type-badge"
              [class.erg-fb-type-issue]="response.feedbackType === 'Issue'"
              [class.erg-fb-type-idea]="response.feedbackType === 'Idea'"
              [class.erg-fb-type-other]="response.feedbackType === 'Other'">
              {{ response.feedbackType }}
            </span>
          </header>

          <div class="erg-fb-response-body">
            <div class="erg-fb-response-score" [attr.aria-label]="ratingLabel(response.experienceRating) + ', ' + response.experienceRating + ' out of 5'">
              <span class="erg-fb-score-value">{{ response.experienceRating }}</span>
              <span class="erg-fb-score-total">/5</span>
              <span class="erg-fb-score-label">{{ ratingLabel(response.experienceRating) }}</span>
            </div>
            <p class="erg-fb-response-details">{{ response.feedbackDetails }}</p>
          </div>

          <footer class="erg-fb-response-user">
            <i class="fa fa-user-o" aria-hidden="true"></i>
            User {{ response.userId }}
          </footer>
        </article>
      </div>

      <div class="erg-fb-actions">
        <button type="button" class="erg-fb-btn-primary" (click)="requestClose()">Close</button>
      </div>
    </section>
  </div>
</div>